<div class="inconsistencias-cadastro">
    <app-painel-lateral
        [tituloPainel]="'Inconsistências de Cadastro'"
        [descricaoPainel]="'Relatório estatístico de inconsistências cadastrais e divergências de dados.'"
        [iconePainel]="'pi pi-exclamation-triangle'"
        [filtrosTemplate]="filtros"
        [conteudoTemplate]="conteudo"
        [ocultarFiltros]="!!indicadorSelecionado"
    >
        <ng-template #filtros>
            <label class="mapa-filtro">
                <span class="mapa-filtro-label">UF do estado</span>
                <app-estado-select [uf]="ufSelecionada ?? 'BR'" [ufsPermitidas]="ufsPermitidas" (ufChange)="onUfSelecionadaChange($event)"></app-estado-select>
            </label>

            <div class="mapa-card">
                <app-mapa-uf class="mapa-uf" [ufSelecionada]="ufSelecionada" (estadoSelecionado)="onMapaUfSelecionado($event)"></app-mapa-uf>
            </div>
        </ng-template>

        <ng-template #conteudo>
            @if (indicadorSelecionado) {
                <app-detalhamento-pendencias
                    [indicador]="obterIndicadorAnalitico()"
                    [linhas]="linhasAnalitico"
                    [first]="firstAnalitico"
                    [rows]="rowsAnalitico"
                    [totalRecords]="totalRegistrosAnalitico"
                    [carregando]="carregandoAnalitico"
                    [rotuloVoltar]="'Voltar às inconsistências'"
                    [voltarNoCard]="true"
                    [permitirVisualizacaoCard]="true"
                    (voltar)="voltarParaMapa()"
                    (paginaAlterada)="onPageChangeAnalitico($event)"
                ></app-detalhamento-pendencias>
            } @else {
                <div class="mapa-indicadores">
                    <div class="indicadores-grid">
                        @for (indicador of indicadores; track indicador.id) {
                            <div class="card-entrada card-entrada-1 indicador-card" [ngClass]="indicador.classeGrupo">
                                <app-card-content [border]="false" [title]="indicador.titulo" [subtitle]="indicador.descricao" [icon]="obterIconeIndicador(indicador)">
                                    <div card-header class="flex items-center gap-2" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarIndicadorAnalitico(indicador)"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarIndicador(indicador)"></p-button>
                                    </div>

                                    <div class="estatistica-total-bloco">
                                        @if (obterQuantidadeIndicador(indicador.indice) !== null) {
                                            <span class="estatistica-total-valor">{{ obterQuantidadeIndicador(indicador.indice) | number }}</span>
                                            <span class="estatistica-total-label">registros</span>
                                        } @else {
                                            <p-skeleton width="92px" height="30px" />
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                        }
                    </div>
                </div>
            }
        </ng-template>
    </app-painel-lateral>
</div>

<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Inconsistências do indicador em tela cheia."
    [(visible)]="exibirModalMaximizado"
    [header]="indicadorMaximizado?.titulo ?? ''"
    [style]="{ width: '90vw', maxWidth: '560px' }"
    [breakpoints]="{ '640px': '95vw' }"
    [dismissableMask]="true"
    (onHide)="indicadorMaximizado = null"
    styleClass="modal-estatistica-custom"
>
    @if (indicadorMaximizado) {
        <div class="estatistica-card modal-card-wrapper" [ngClass]="indicadorMaximizado.classeGrupo">
            <div class="estatistica-topo">
                <div class="estatistica-identidade">
                    <span class="estatistica-icone">
                        <i [class]="obterIconeIndicador(indicadorMaximizado)"></i>
                    </span>
                    <p-tag [rounded]="true" class="grupo-badge">{{ indicadorMaximizado.grupo }}</p-tag>
                </div>

                <div class="estatistica-acoes">
                    <p-button
                        icon="pi pi-table"
                        styleClass="botao-topo-acao"
                        [text]="true"
                        [rounded]="true"
                        title="Visualizar dados estatísticos"
                        ariaLabel="Visualizar dados estatísticos"
                        (onClick)="selecionarIndicadorAnalitico(indicadorMaximizado)"
                    ></p-button>
                </div>
            </div>

            <div class="estatistica-total-bloco">
                @if (obterQuantidadeIndicador(indicadorMaximizado.indice) !== null) {
                    <span class="estatistica-total-valor">{{ obterQuantidadeIndicador(indicadorMaximizado.indice) | number }}</span>
                    <span class="estatistica-total-label">registros</span>
                } @else {
                    <p-skeleton width="92px" height="30px" />
                }
            </div>

            <p class="estatistica-descricao">{{ indicadorMaximizado.descricao }}</p>
        </div>
    }
</p-dialog>
